import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "member_details_body"
};
const _hoisted_2 = {
  style: {
    "position": "relative",
    "overflow": "hidden"
  }
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "width": "100%",
    "flex-direction": "column",
    "align-items": "center"
  }
};
const _hoisted_4 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("p", {
    class: "html",
    innerHTML: $setup.hd_data.status == '未激活' ? $setup.hd_data.unDetails : $setup.hd_data.details,
    style: {
      "margin-bottom": "100px"
    }
  }, null, 8, _hoisted_4), $setup.hd_data.status == '未激活' ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: "https://www.mimodental.com/assets/imgData/img/new/wjh_btn.png",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.call && $setup.call(...args)),
    alt: ""
  })) : _createCommentVNode("", true)])])]);
}